import React, {useState, useCallback, useEffect, useRef} from "react";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import style from "./block.module.scss";
import ShareButton from "../assets/shareButton.svg";
import Facebook from "../assets/facebook.svg";
import Twitter from "../assets/twitter.svg";
import LinkedIn from "../assets/linkedIn.svg";
import Copy from "../assets/copy.svg";

function Share(){
    const ref = useRef();

    const [show, setShow] = useState(true);

    const navListener = useCallback( (e) => {
        let element = document.getElementById("shareAnchorEnd");
        if(element && ref.current){
            let position = element.getBoundingClientRect().top;
            if(position < ref.current.getBoundingClientRect().bottom){
                setShow(false);
            }
            else{
                setShow(true);
            }
        }
       
    }, [ref]);

    useEffect(() => {
        window.addEventListener("scroll", navListener);
        window.addEventListener("resize", navListener);
        return () => {
            window.removeEventListener("scroll", navListener);
            window.removeEventListener("resize", navListener);
        }
    }, [navListener]);


    const [open, setOpen] = useState(false);
    const [copyToolbox, setCopyToolbox] = useState(false);
    return <div className={show ? style.block : style.hidden} ref={ref}>
                        <div className={style.shareButton} onClick={() => {setOpen(!open)}} >
                            <img src={ShareButton} alt="Open Share Menu" />
                        </div>
                        <div className={style.shareMenu}>
                            <a className={style.icon} href={"http://www.facebook.com/sharer.php?u=" + window.location.href}  rel="noopener noreferrer" target="_blank">
                                <img src={Facebook} alt="share on facebook" />
                            </a>
                            <a className={style.icon} href={"http://www.twitter.com/share?url=" + window.location.href}  rel="noopener noreferrer" target="_blank">
                                <img src={Twitter} alt="share on twitter" />
                            </a>
                            <a className={style.icon} href={"https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href}  rel="noopener noreferrer" target="_blank">
                                <img src={LinkedIn} alt="share to linkedin" />
                            </a>
                            <CopyToClipboard text={window.location.href} onCopy={() => setCopyToolbox(true)}>
                                <div className={style.icon}>
                                    <img src={Copy} alt="Copy to clipboard"/>
                                </div>
                            </CopyToClipboard>
                            <Snackbar
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    open={copyToolbox}
                                    autoHideDuration={3000}
                                    onClose={() => setCopyToolbox(false)}
                                    message="Copié dans le presse papier"
                                    action={
                                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => setCopyToolbox(false)}>
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    }/>
                            </div>
                </div>
}

export default Share;